import Vue                       from "vue";
import { mapGetters }            from "vuex";
import { ErrorLogService,
         EventTrackingService,
         PartDetailServices }    from "@/services";
import { LoadingSpinner, 
         StaticFormControl }     from "@/components";
import {  DnFormInput }          from "@/components/Elements";
import { inputValidateState }    from "@/components/mixins/inputValidateState";
import { default as SendError }  from "../SendError.vue";
import { default as ThankYou }   from "../ThankYou.vue";
import { IUserInfo }             from "@/types";

export default Vue.extend({
    name: "SuggestPartApplication",
    mixins: [inputValidateState],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        StaticFormControl,
        DnFormInput
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId", "SiteName"]),

        formIsValid(){
            var allRequiredFieldsHaveBeenFilledOut = 
                this.oem != "" &&
                this.series != "" &&
                this.modelNumber != "" &&
                this.serial != "" &&
                this.sourceOfInformation != "";
            return allRequiredFieldsHaveBeenFilledOut;
        }
    },
    props: {
        oemPartCode: {
            type: String,
            default: "",
        }
    },
    data: () => ({
        showThankYou: false,
        showSendError: false,
        isBusy: false,
        errorMessage: "",

        // form fields
        oem: "",
        series: "",
        modelNumber: "",
        serial: "",
        sourceOfInformation: "",
        comment: "",
    }),
    methods: {
        async submitForm() {
            try {
                this.showThankYou = false;
                this.isBusy = true;

                var urlParams = {
                    oemPartCode: this.oemPartCode,
                    siteName: this.SiteName,
                    oem: this.oem,
                    series: this.series,
                    modelNumber: this.modelNumber,
                    serial: this.serial,
                    comments: this.comment,
                    source: this.sourceOfInformation
                }


                await PartDetailServices.suggestPartApplication(urlParams,this.user);

                EventTrackingService.trackEvent({
                  category: "Part Detail",
                  action: "Application Suggestion",
                  label: `${this.oem}-${this.modelNumber}`,
                  value: 1,
                });

                this.showThankYou = true;
            } catch (err) {
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.isBusy = false;
            }
        },
        hideForm(){
            this.$emit("hide");
        }
    },
});
